module.exports = __webpack_public_path__ + "img/img3.a8b83325.png";